module.exports = __webpack_public_path__ + "img/Word2vec.4e01fc23.png";